import { useState } from "react";
import { FaAward } from "react-icons/fa";

import styles from "./Cards.module.css";

const pricingData = [
    {
        id: "minicourse",
        tier: "Mini-Course Only",
        intFee: "$ 300.00",
        indFee: "INR 5,000.00",
    },
    {
        id: "fullaccess",
        tier: "Conference only",
        intFee: "$ 1,050.00",
        indFee: "INR 29,500.00",
        // badge: "Most Popular",
    },
    {
        id: "retiree",
        tier: "Conference only for retirees",
        intFee: "$ 500.00",
        indFee: "INR 10,000.00",
    },
    {
        id: "student",
        tier: "Conference only for students",
        intFee: "$ 250.00",
        indFee: "INR 5,000.00",
        // badge: "Best Value",
    },
    {
        id: "singleday",
        tier: "Single-Day Entry Pass",
        intFee: "$ 425.00",
        indFee: "N/A",
    },
];

// One accent colour per tier, cycled by index.
const accentColors = ["#0ea5e9", "#1d63c7", "#16a34a", "#d97706", "#7c3aed"];

/**
 * Renders the registration pricing data as one animated,
 * colour-coded row of cards (in place of a plain table).
 */
const PricingCards = () => {
    const [filter, setFilter] = useState("all");

    const items =
        filter === "all"
            ? pricingData
            : pricingData.filter((item) => item.id === filter);

    return (
        <>
            <div className={styles.discountBanner}>
                <FaAward />
                <span>10% discount available for IEEE Members</span>
            </div>

            <select
                className={styles.customSelect}
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
            >
                <option value="all">Show All Tier Categories</option>

                {pricingData.map((item) => (
                    <option key={item.id} value={item.id}>
                        {item.tier}
                    </option>
                ))}
            </select>

            <div className={styles.cardRow}>
                {items.map((item, index) => (
                    <div
                        key={item.id}
                        className={styles.priceCard}
                        style={{
                            "--accent": accentColors[index % accentColors.length],
                            animationDelay: `${index * 0.08}s`,
                        }}
                    >
                        {item.badge && (
                            <span className={styles.priceBadge}>
                                {item.badge}
                            </span>
                        )}

                        <span className={styles.priceTier}>
                            {item.tier}
                        </span>

                        <div className={styles.priceRow}>
                            <span>International</span>
                            <strong>{item.intFee}</strong>
                        </div>

                        <div className={styles.priceRow}>
                            <span>Indian</span>
                            <strong>{item.indFee}</strong>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default PricingCards;